import { useAtom, useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { radarTemplateNameAtom, unwrappedRadarTemplateNameErrorAtom } from '@/atoms/radar';
import { NameInput } from '@/components/input/NameInput';
import { CONFIG_NAME_MAX_LENGTH } from '@/consts/userConfigs';

export const RadarTemplateNameInput = () => {
  const { t } = useTranslation('input');
  const [radarTemplateName, setRadarTemplateName] = useAtom(radarTemplateNameAtom);
  const radarTemplateNameError = useAtomValue(unwrappedRadarTemplateNameErrorAtom);

  const errorMessage = radarTemplateNameError
    ? t(`name.error.${radarTemplateNameError}`, { max: CONFIG_NAME_MAX_LENGTH })
    : undefined;

  return (
    <div className="p-4 w-[332px]">
      <NameInput
        id="radar-template-name"
        value={radarTemplateName}
        onChange={e => setRadarTemplateName(e.target.value)}
        errorMessage={errorMessage}
      />
    </div>
  );
};
